export enum BaseDataKey {
  productCategory = 'product_category',
  jawType = 'jaw_type',
  rootType = 'root_product_type',
  baseColorCategory = 'color_system',
}
